export default {"src":"/evde-internet/_next/static/media/tobi-sad.f5245c73.svg","height":72,"width":72};